module.exports = __webpack_public_path__ + "img/backtotop.54c21a68.svg";